import label from "@/lang/StaticLabels.js";

// Tax Navbar  - سامانه مودیان -----------------------------------------------
let navItems = [
  {
    title: label.modules.ptax,
    icon: "mdi-receipt-text-outline",
    to: false,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PTAXKey",
        label: label.menu.taxKeys,
        metaLabel: label.page.taxKeys,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: "PTAXSaleFactorInvoice",
        label: label.menu.saleFactorInvoice,
        metaLabel: label.page.saleFactorInvoice,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PTAXImportExcel",
        label: label.menu.importExcelTaxInvoice,
        metaLabel: label.page.importExcelTaxInvoice,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PTAXInvoice",
        label: label.menu.taxInvoices,
        metaLabel: label.page.taxInvoices,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
